import { spApi } from './sp';

export const previewApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    setPreviewAttribution: builder.mutation({
      query: ({ slug, captured_at }) => ({
        url: '/preview/attribution',
        method: 'POST',
        body: { slug, captured_at },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSetPreviewAttributionMutation } = previewApi;